<template>
  <!-- <div class="title">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <h2 class="mb-0">{{ this.$route.name }}</h2>
          <li class="breadcrumb-item">
            <a href="/">
              <i class="fas fa-home"></i>
            </a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">{{ this.$route.name }}</li>
        </ol>
      </nav>
  </div>-->

  <div class="title">
    <b-breadcrumb class="breadcrumb">
      <!-- <h2 class="mb-0">{{ this.$route.name }}</h2> -->
      <b-breadcrumb-item to="/dashboard">
        <i class="fas fa-home"></i>
      </b-breadcrumb-item>


      <b-breadcrumb-item
        class="breadcrumb-item"
        v-if="this.$route.meta.parent && this.$route.meta.parent.path "
        :to="this.$route.meta.parent.path"
      >{{ this.$route.meta.parent.name }}</b-breadcrumb-item>
      <b-breadcrumb-item
        class="breadcrumb-item"
        v-if="this.$route.meta.parent && this.$route.meta.parent.path === undefined"
        active
      >{{ this.$route.meta.parent.name }}</b-breadcrumb-item>


      <b-breadcrumb-item
        :class="{'router-link-active': isSelected}"
        v-if="this.$route.children"
        active
      >{{this.$route.children[0].name}}</b-breadcrumb-item>


      <b-breadcrumb-item
        class="breadcrumb-item"
        v-if="this.$route.meta.parent && this.$route.meta.parent.path === '/construction'"
        active
      >{{info.name}}</b-breadcrumb-item>


      <b-breadcrumb-item class="breadcrumb-item" v-else active>{{ this.$route.name }}</b-breadcrumb-item>
    </b-breadcrumb>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TheBreadcrumb",
  data() {
    return {};
  },
  computed: {
    ...mapGetters("construction", ["info"]),

    isSelected() {
      if (this.item.children) {
        return this.$route.matched.some(
          record => record.name === this.item.name
        );
      }
      return false;
    }
  },
  function(record) {
 return record.name === this.item.name;
}
};
</script>